import { useEffect, useRef } from "react";
import { useCreatePlayTestMetaData, useGamePlayTestMetaData } from "@seabrookstudios/pitch2table";
import { useSnackbar } from "notistack";
import {
  findNestiFyzScoreMetadata,
  NESTIFYZ_SCORE_METADATA_NAME,
  NESTIFYZ_SCORE_METADATA_TYPE,
} from "./playtestImportUtils";

/**
 * Ensures the game has a SCORE tracking variable for NestiFyz play test imports.
 *
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 * @param {() => void} props.onComplete
 * @param {() => void} props.onError
 */
export const GameImportPlayTestScoreMetadata = ({ gameId, onComplete, onError }) => {
  const { data: metadata = [], isLoading } = useGamePlayTestMetaData(gameId);
  const createMetadata = useCreatePlayTestMetaData(gameId);
  const hasStarted = useRef(false);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (isLoading || hasStarted.current) {
      return;
    }

    if (findNestiFyzScoreMetadata(metadata)) {
      hasStarted.current = true;
      onComplete();
      return;
    }

    hasStarted.current = true;

    createMetadata
      .mutateAsync({
        name: NESTIFYZ_SCORE_METADATA_NAME,
        type: NESTIFYZ_SCORE_METADATA_TYPE,
        valueType: "NUMERIC",
        enumTypes: undefined,
        colour: "#000000",
        pattern: undefined,
      })
      .then(() => {
        onComplete();
      })
      .catch(() => {
        enqueueSnackbar("An error occurred preparing play test score tracking", { variant: "error" });
        onError();
      });
  }, [createMetadata, isLoading, metadata, onComplete, onError, enqueueSnackbar]);

  return null;
};
